import { render } from "./LkSetupView.vue?vue&type=template&id=6ff628f8"
import script from "./LkSetupView.vue?vue&type=script&lang=js"
export * from "./LkSetupView.vue?vue&type=script&lang=js"

import "./LkSetupView.vue?vue&type=style&index=0&id=6ff628f8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__